import { type ReactNode } from "react";
import styles from "./TextContainer.module.css";

//#region [Props]
type TextContainerProps = {
    children: ReactNode;
};
//#endregion

//#region [Component]
export default function TextContainer({ children }: TextContainerProps) {
    return <div className={styles.TextContainer}>{children}</div>;
}
//#endregion

//#region [Styles]

//#endregion